module.exports = __webpack_public_path__ + "static/media/advantages_6.ed7fdada.svg";